import { safeNumericString } from 'app/infrastructure/data/sanitize';
import { deepEquals } from 'app/infrastructure/js/deep-equals';
import { DefaultContainerProps } from 'app/infrastructure/redux';
import { DashboardAdminState } from '../types-store';
import { filtersHaveChanges } from 'app/area/shared/default-filters/utils/filters-have-changes';
import { hasChanges } from './utils/has-changes';
import { selectorId } from 'app/area/shared/selector-id';

export interface DashboardFormSelectorProps {
  shouldPrompt: boolean;
  id: number;
  favouriteId: number;
  section: string;
}

type DashboardFormSelectors = { [T in keyof DashboardFormSelectorProps]?:
  (state: DashboardAdminState, props: DefaultContainerProps) => DashboardFormSelectorProps[T] };

export const selectors: DashboardFormSelectors = {
  shouldPrompt: ({ form }) =>
    hasChanges(form?.dashboardItem, form?.originalDashboardItem) ||
    !deepEquals(form?.savedReports, form?.originalSavedReports) ||
    filtersHaveChanges(form?.filters, form?.originalFilters),
  id: (_, { params }) => selectorId(params?.id),
  favouriteId: (_, { router }) =>
    safeNumericString(router?.location?.query?.favouriteId) || undefined,
  section: (_, { params }) =>
    params?.section || undefined
};
